import axios from "axios";

const instance = axios.create({
  baseURL: "https://api.goodbuy-books.ml",
  headers: {
    "Content-Type": "application/json",
  },
});

export default instance;
